<script>
import api from '../../../helpers/apirest/api';
import Status from "../../../helpers/general/status";
/**
 * Revenue by Locations component
 */
export default {
  data() {
    return {
      loading:false,
      totals:[],
      series: [],
      chartOptions: {
        chart: {
          type: "area",
          height: 196,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: ["#505d69", "#4aa3ff", "#1cbb8c", "#ff3d60"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          curve: "smooth",
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          },
        },
        legend: {
          show: false,
        },
        labels: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            show: false,
          },
        },
         yaxis: {
          labels: {
            show: false,
          },
        },
      },
    };
  },
  created(){
    this.loadData();
  },
  methods:{
    async loadData(type){
      try{
        this.loading = true;
        const data = await api.get({
          url: 'customer-task-imports/status-metric',
          params: {
            'type': type || 'this-week'
          }
        });
        const series = data?.data?.data?.series;
        const categories = data?.data?.data?.categories;
        const totals = data?.data?.data?.totals;

        this.series = series.map(item => {
          return {
            name: Status.getStatus({itemStatus: item?.serie, type: 'customer_task_import', html: false}),
            data: item?.data
          }
        });


        this.chartOptions = {...this.chartOptions, ...{
            xaxis: {
                categories: categories
            }
        }}

        this.totals = totals;

        this.loading = false;

      }catch(error){
        this.loading = false;
      }
      
    },
    status(status){
      return Status.getStatus({itemStatus: status, type: 'customer_task_import'});
    }
  },
  computed:{
    
  }
};
</script>

<template>
  <div class="card h-100">
    <div class="card-body">
       <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <!-- item-->
        <b-dropdown-item @click="loadData('this-week')">This Week</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item @click="loadData('last-week')">Last Week</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item @click="loadData('this-month')">This Month</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item @click="loadData('last-month')">Last Month</b-dropdown-item>
      </b-dropdown>

      <h4 class="card-title mb-4">Tasks by status <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span></h4>
      <apexchart
        type="area"
        height="182"
        :options="chartOptions"
        :series="series"
      ></apexchart>

      <div class="row justify-content-center">
        <div class="col-xs-12 col-md-6" v-for="(item, idx) in totals" :key="idx">
          <div class="clearfix py-2">
            <h5 class="float-right font-size-16 m-0">{{ item?.count }}</h5>
            <p class="text-muted mb-0 text-truncate"><span v-html="status(item?.status)"></span> :</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>